function TermsAndConditions() {
  return (
    <div className="min-h-screen">
      <h1>Tearms & Conditions</h1>
    </div>
  );
}

export default TermsAndConditions;
